export default "__VITE_ASSET__7dCQRkTS__"